/**
 * This route is dynamically added to the app if this section is
 * enabled inside the config for the tenant being built.
 */
// @ngInject
function states($stateProvider) {
  $stateProvider
    .state('pre-onboarding', {
      url: '',
      controller: 'AcpPreOnboardingTransactCtrl as vm',
      redirectTo: '.start',
      templateUrl:
        'sections/pre-onboarding-transact/templates/acp-pre-onboarding-transact.ng.html',
      resolve: {
        module: /* @ngInject */ function($ocLazyLoad) {
          return import(/* webpackChunkName: "acp.section.pre-onboarding-transact" */ 'sections/pre-onboarding-transact').then(
            $ocLazyLoad.loadModule
          );
        }
      }
    })
    .state('pre-onboarding.start', {
      url: '/pre-onboarding',
      templateUrl:
        'sections/pre-onboarding-transact/templates/acp-pre-onboarding-transact-start.ng.html'
    });
}

export default states;
